exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.dynamic-form_container {\n  width: 100%;\n  height: 100%;\n}\n.dynamic-form_container > .dynamic-table-container {\n    height: 100%;\n}\n.dynamic-form_container > .dynamic-table-container > .cm-list-content-layout {\n      height: calc(100% - 45px);\n}\n.dynamic-form_container > .dynamic-tabs-container > .el-tabs__content {\n    height: calc(100% - 69px);\n    overflow: auto;\n}\n.dynamic-form_container > .dynamic-tabs-container > .el-tabs__content > .el-tab-pane {\n      height: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2c61aba","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dynamic/index.vue
// module id = LCGY
// module chunks = 289